<template>
<div class="odr-align-center">
    <div class="odr-align-center__content"
         :class="{
             'odr-align-center__content_text': textAlign
         }">
        <slot> </slot>
    </div>
</div>
</template>

<script>
import '../styles/align-center.scss'
export default {
    props: {
        'text-align': {
            type: String,
            _descr: 'Set text-align: center',
        },
    },
}
</script>
